import { IUserLink } from "services/types";
import { metrics } from "utils/metrics";

interface IProps {
  userName: string;
  links: IUserLink[];
}

export const Links = (props: IProps) => {
  const { links } = props;

  if (links.length === 0) {
    return <></>;
  }

  const onClickSocialLink = async (type: string) => {
    await metrics.sendSocialProfileClick({
      userName: props.userName,
      type: type
    });
  };

  const renderLink = (link: IUserLink, idx: number, last: boolean) => {
    const name = link.domain.split(".")[0];

    return (
      <li className={`CreatorInfo-SocialItem CreatorInfo-SocialItem_${name}`} key={idx}>
        <a
          href={link.url}
          target="_blank"
          rel="noreferrer"
          onClick={() => onClickSocialLink(name)}
        >
          <span>{link.domain}</span>
        </a>
      </li>
    );
  };

  return (
    <div className="CreatorInfo-Social">
      <div className="h4">Follow on:</div>
      <ul className="CreatorInfo-SocialList">
        {links.map((link: IUserLink, index: number) => renderLink(link, index, index === links.length - 1))}
      </ul>
    </div>
  );
};
